export const Routes = [
  {
    id: 1,
    identifier: "about",
    title: "About",
    dropdown: [
      {
        id: 1,
        title: "Vision",
        identifier: "vision",
      },
      {
        id: 3,
        title: "People",
        identifier: "people",
      },
      {
        id: 4,
        title: "press",
        identifier: "press",
        isDifferentPage: true,
      },
      {
        id: 4,
        title: "Charter",
        identifier: "winpecharter",
        isDifferentPage: true,
      },
    ],
  },
  {
    id: 2,
    identifier: "initiatives",
    title: "Initiatives",
    dropdown: [
      {
        id: 1,
        title: "Events",
        identifier: "events",
        isDifferentPage: true,
      },
      {
        id: 2,
        title: "Testimonials",
        identifier: "testimonials",
        isDifferentPage: true,
      },
    ],
  },
  {
    id: 3,
    identifier: "insights",
    title: "insights",
    isDifferentPage: true,
    // dropdown: [
    // 	{
    // 		id: 1,
    // 		title: "Kirthiga Reddy of SoftBank Investment Advisers",
    // 		identifier: "superpowerofand",
    // 		isDifferentPage: true,
    // 	},
    // 	{
    // 		id: 1,
    // 		title: "Inclusive Leadership: The Next Normal",
    // 		identifier: "inclusiveleadership",
    // 		isDifferentPage: true,
    // 	},
    // 	{
    // 		id: 1,
    // 		title: "Lizzie chapman of ZestMoney",
    // 		identifier: "navigatingfundraising",
    // 		isDifferentPage: true,
    // 	},
    // 	{
    // 		id: 1,
    // 		title: "Diversity at Risk: The Next Normal",
    // 		identifier: "diversityatrisk",
    // 		isDifferentPage: true,
    // 	},
    // 	{
    // 		id: 1,
    // 		title: "Manisha Girotra of Moelis & Company",
    // 		identifier: "holdingmyown",
    // 		isDifferentPage: true,
    // 	},
    // 	{
    // 		id: 1,
    // 		title: "Reimagining the Workplace: The Next Normal",
    // 		identifier: "reimaginingtheworkplace",
    // 		isDifferentPage: true,
    // 	},
    // 	{
    // 		id: 1,
    // 		title: "Padmaja Ruparel of Indian Angel Network",
    // 		identifier: "padmajaruparelofindianangelnetwork",
    // 		isDifferentPage: true,
    // 	},
    // 	{
    // 		id: 1,
    // 		title: "Alagappan Murugappan of CDC Group",
    // 		identifier: "changingtimesadfiperspective",
    // 		isDifferentPage: true,
    // 	},
    // 	{
    // 		id: 2,
    // 		title: "Shweta Jalan of Advent International",
    // 		identifier: "shwetajalanofadventinternational",
    // 		isDifferentPage: true,
    // 	},
    // 	{
    // 		id: 3,
    // 		title: "Bala C Deshpande of MegaDelta Capital",
    // 		identifier: "thestockdaleparadox",
    // 		isDifferentPage: true,
    // 	},
    // 	{
    // 		id: 4,
    // 		title: "Nupur Garg of WinPE Forum",
    // 		identifier: "myLPmusings",
    // 		isDifferentPage: true,
    // 	},
    // 	{
    // 		id: 4,
    // 		title: "Celebrating Women in Investing",
    // 		identifier: "celebratingwomenininvesting",
    // 		isDifferentPage: true,
    // 	},
    // ]
  },
  {
    id: 4,
    identifier: "partners",
    title: "Partners",
    // dropdown: [
    //   // {
    //   // 	id: 2,
    //   // 	title: "Partner Manifesto",
    //   // 	identifier: "winpemanifesto",
    //   // },
    // ],
  },
  {
    id: 5,
    identifier: "knowledgeresources",
    title: "knowledge center",
    isDifferentPage: true,
  },
  {
    id: 6,
    identifier: "connect",
    title: "Connect",
    isDifferentPage: true,
    // dropdown: [
    // 	{
    // 		id: 1,
    // 		title: "Careers",
    // 		identifier: "careers",
    // 		isDifferentPage: true
    // 	},
    // ]
  },
];

export default Routes;



// WEBPACK FOOTER //
// ./src/components/Routes.js